import { RouteObject } from "react-router";
import DownloadResultSet from "./DownloadResultSet";

const routes: RouteObject = {
  path: "download",
  Component: DownloadResultSet,
};
export default routes;
